// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#ffb65e","subMenuActiveText":"#ffb65e","menuBg":"#0073B9","menuHover":"rgba(0,0,0,0.15)","subMenuBg":"rgba(147,189,224,0.3)","subMenuHover":"rgba(0,0,0,0.15)","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 77